/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloudWiseUsageResponse {
    getFixupPrototypeFunction() { return CloudWiseUsageResponse.fixupPrototype; }

    static newInstance(model: Partial<CloudWiseUsageResponse>): CloudWiseUsageResponse {
        let obj = Object.assign(new CloudWiseUsageResponse(), model);
        CloudWiseUsageResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloudWiseUsageResponse>): CloudWiseUsageResponse {
        if (!model) return null;
        return CloudWiseUsageResponse.newInstance(<CloudWiseUsageResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloudWiseUsageResponse) {
        if (!obj) return;

        models.CloudWiseUsageResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloudWiseUsageResponse): boolean {
        Object.setPrototypeOf(obj, CloudWiseUsageResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_details) {
            for (let val of this.cost_details) {
                models.ServiceNameWiseUsage.fixupPrototype(val);
            }
        }
        if (this.inventory_details) {
            for (let val of this.inventory_details) {
                models.InventoryWiseUsage.fixupPrototype(val);
            }
        }
    }

    /**
     * List of service name-wise usage data
     */
    cost_details: Array<models.ServiceNameWiseUsage>;

    /**
     * List of inventory-wise usage data
     */
    inventory_details: Array<models.InventoryWiseUsage>;

}
